interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;
  const pages = Array.from({ length: total }, (_, i) => i + 1);

  return (
    <div className="flex items-center justify-center gap-2 mt-10">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className="w-9 h-9 flex items-center justify-center rounded-md border border-background-200 text-foreground-600 hover:border-primary-400 hover:text-primary-600 transition-colors disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer"
      >
        <i className="ri-arrow-left-s-line text-lg" />
      </button>
      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          className={`w-9 h-9 flex items-center justify-center rounded-md text-sm font-medium transition-colors cursor-pointer ${
            page === current
              ? "bg-primary-500 text-background-50"
              : "border border-background-200 text-foreground-600 hover:border-primary-400 hover:text-primary-600"
          }`}
        >
          {page}
        </button>
      ))}
      <button
        type="button"
        onClick={() => onChange(Math.min(total, current + 1))}
        disabled={current === total}
        className="w-9 h-9 flex items-center justify-center rounded-md border border-background-200 text-foreground-600 hover:border-primary-400 hover:text-primary-600 transition-colors disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer"
      >
        <i className="ri-arrow-right-s-line text-lg" />
      </button>
    </div>
  );
}